import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Input from 'components/ui/Input';
import {
  StyledGroupPassengerSelect,
  StyledGroupPassengerSelection,
  StyledGroupPassengerSelectItem,
  StyledErrorMessage,
  StyledDescription,
  StyledLabel
} from './GroupPassengerSelection.styles';
import { PAX_DESCRIPTIONS } from 'constants/booking';

const paxTypes = ['adults', 'seniors', 'children', 'youths'];

const GroupPassengerSelection = ({ passengers, passengerRangeError, onChangePassengers }) => (
  <StyledGroupPassengerSelection>
    <StyledGroupPassengerSelect>
      {paxTypes.map((passengerType) => (
        <StyledGroupPassengerSelectItem data-testid={passengerType} key={passengerType}>
          <StyledLabel for={passengerType}>
            <FormattedMessage id={`groupBooking.${passengerType}Title`} />
            <StyledDescription>
              (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS[passengerType]}`} />)
            </StyledDescription>
          </StyledLabel>
          <Input
            id={passengerType}
            name={passengerType}
            value={passengers[passengerType] === 0 ? '' : passengers[passengerType]}
            maxLength="2"
            onChange={(e) => {
              const number = parseInt(e.target.value, 10);
              onChangePassengers({ [passengerType]: Number.isInteger(number) ? number : 0 });
            }}
            placeholder="0"
          />
        </StyledGroupPassengerSelectItem>
      ))}
      <StyledErrorMessage id="group-booking-error">
        {passengerRangeError && <FormattedMessage id={`groupBooking.${passengerRangeError}`} />}
      </StyledErrorMessage>
    </StyledGroupPassengerSelect>
  </StyledGroupPassengerSelection>
);

GroupPassengerSelection.propTypes = {
  passengers: PropTypes.shape(),
  onChangePassengers: PropTypes.func,
  passengerRangeError: PropTypes.string
};

export default GroupPassengerSelection;
